import React, { useMemo } from 'react';
import { Skeleton } from 'antd';

import useStep from './useQuestionSteps';
import Question, { SelectionWrapper, QUES_COMPONENTS } from './question';
import Action from './ActionButtons';

const getQuesComp = (type) => {
  if (!Object.keys(QUES_COMPONENTS).includes(type)) {
    return null;
  }
  return { ...QUES_COMPONENTS[type] };
};

const renderQuesComp = (type, steps) => {
  const Comp = getQuesComp(type);
  return Comp ? <Comp steps={steps} /> : <div />;
};

function QuestionContent(props) {
  const steps = useStep();
  const {
    step,
    quesData,
    isFetchLoading,
    isActionLoading,
    answer,
    sequence,
    markNotApplicable,
  } = steps;

  const quesComp = useMemo(
    () => renderQuesComp(quesData.type, steps),
    [sequence, quesData.type, answer],
  );

  return (
    <div className="questionnaires-step-content-wrapper">
      {step}
      <div className="questionnaires-content">
        <Skeleton loading={isFetchLoading} active>
          <Question
            stem={quesData}
            markNotApplicable={markNotApplicable}
            steps={steps}
          >
            <SelectionWrapper
              ref={steps.register}
              {...quesData}
              values={answer}
              isLoading={isActionLoading}
            >
              {quesComp}
            </SelectionWrapper>
          </Question>
        </Skeleton>

        <Action steps={steps} />
      </div>
    </div>
  );
}

QuestionContent.propTypes = {};

export default QuestionContent;
